export default "<i class=\"fa fa-envelope\" style=\"width:30px\"> </i> <span> contato@atelie.digital </span><br>"